import React, { useEffect } from 'react'
import Styles from './styles.module.sass'
import HeaderSubMenu from 'newComponents/HeaderSubMenu';
import AsideGuestLayout from '../AsideGuestLayout';

const CreditoGuestLayout = ({ children, flow, hideMenu = false }) => {

  return (
    <>
      <AsideGuestLayout flow={flow} />
      <div className={Styles?.contCreditLayout}>
        {!hideMenu &&
          <HeaderSubMenu />
        }
        <div
          className={Styles?.moduleCardSubLayout}
        >{children}</div>
      </div>
    </>
  );
}

export default CreditoGuestLayout;